import {correctCustomerOfferOutcome} from "@project/sdk/sales";
import {CorrectCustomerOfferOutcomeResponse} from "@project/sdk/sales/zod";
import {mutationOptions} from "@tanstack/react-query";
import {customerOfferKeys, customerOfferMutationKeys} from "../../../customerOffer-keys";

export function correctCustomerOfferOutcomeMutationOptions() {
  return mutationOptions({
    mutationKey: customerOfferMutationKeys.correctCustomerOfferOutcome,
    retry: false,
    mutationFn: async (id: string) =>
      CorrectCustomerOfferOutcomeResponse.parse(await correctCustomerOfferOutcome(id)),
    onSuccess: async (_result, id, _context, {client}) => {
      await Promise.all([
        client.invalidateQueries({queryKey: customerOfferKeys.detail(id)}),
        client.invalidateQueries({queryKey: customerOfferKeys.lists()}),
      ]);
    },
  });
}
